<div fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" [multiTemplateDataRows]="true" class="regular-table responsive"
               matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header="name">Extension</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Extension:</span>
          <a *ngIf="hasEditAccess || (hasEditOwnAccess && row.name === userExtension)" [routerLink]="[row.id]">
            {{ row.name }}
          </a>
          <span *ngIf="!hasEditAccess && !(hasEditOwnAccess && row.name === userExtension)">{{ row.name }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fullName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="fullName">Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Name:</span>
          {{ row.fullName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="cellDis">
        <mat-header-cell *matHeaderCellDef mat-sort-header="cellDis">Cell Phone</mat-header-cell>
        <mat-cell *matCellDef="let row" style="flex-wrap: wrap;">
          <span class="mobile-label">Cell Phone:</span>
          <span *ngFor="let a of row.cellDis; let index = index" style="padding-right: 5px; white-space: nowrap;">
            {{a | phoneNumber}}{{index + 1 == row.cellDis.length ? '' : ','}}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="emailAddress">
        <mat-header-cell *matHeaderCellDef mat-sort-header="emailAddress">Email</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Email:</span>
          {{ row.emailAddress }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="mac">
        <mat-header-cell *matHeaderCellDef mat-sort-header="mac">Mac Addresses</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Mac Addresses:</span>
          {{ row.mac | macAddress }}
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
